import React, { useState } from 'react';
import './HomeDashboardCards.css';
import StreakReminderModal from './StreakReminderModal';
import AiSocialAnalysisModal from './AiSocialAnalysisModal';
import StreakDashboardCard from './StreakDashboardCard';
import { trackButtonClick, BUTTON_ENUMS } from './userJourneyTracker';

export default function HomeDashboardCards({
  streakCount = 1,
  streakCardRef,
  onTurnOnReminders,
  onAnalyseSocial,
  isPremiumUser = false,
  streakCardHighlight = false,
  hideStreakCard = false,
}) {
  const [isStreakReminderOpen, setIsStreakReminderOpen] = useState(false);
  const [isAiAnalysisOpen, setIsAiAnalysisOpen] = useState(false);

  const handleRemindMe = () => {
    trackButtonClick(BUTTON_ENUMS.STREAK_REMIND_ME_CLICKED);
    setIsStreakReminderOpen(true);
  };
  const handleConnectInstagram = () => {
    trackButtonClick(BUTTON_ENUMS.AI_SOCIAL_ANALYSIS_CONNECT_CLICKED);
    setIsAiAnalysisOpen(true);
  };

  return (
    <div className="home-dashboard-cards">
      <svg width="0" height="0" className="home-dash-btn-outline-defs" aria-hidden="true">
        <defs>
          <linearGradient id="home-dash-ig-grad" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#5170ff" />
            <stop offset="100%" stopColor="#ff66c4" />
          </linearGradient>
        </defs>
      </svg>
      <StreakDashboardCard
        count={streakCount}
        innerRef={streakCardRef}
        className={[
          hideStreakCard ? 'streak-card-hidden-during-overlay' : '',
          streakCardHighlight ? 'streak-card-highlight' : '',
        ].filter(Boolean).join(' ')}
        buttonInteractive
        onRemindClick={handleRemindMe}
      />

      <article className="home-dash-card home-dash-card-premium">
        <span className="home-dash-new-label">New</span>
        <div className="home-dash-card-body">
          <p className="home-dash-headline-lg">AI</p>
          <p className="home-dash-headline-md">social analysis</p>
          <p className="home-dash-card-sub">Tailored to your audience</p>
          <button
            type="button"
            className="home-dash-btn home-dash-btn-outline"
            onClick={handleConnectInstagram}
          >
            <svg className="home-dash-btn-outline-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <rect x="2" y="2" width="20" height="20" rx="5" stroke="url(#home-dash-ig-grad)" strokeWidth="2" />
              <circle cx="12" cy="12" r="4" stroke="url(#home-dash-ig-grad)" strokeWidth="2" />
              <circle cx="17.5" cy="6.5" r="1.25" fill="url(#home-dash-ig-grad)" />
            </svg>
            <span className="home-dash-btn-outline-text">Connect Instagram</span>
          </button>
        </div>
      </article>

      <StreakReminderModal
        isOpen={isStreakReminderOpen}
        onClose={() => setIsStreakReminderOpen(false)}
        onTurnOnReminders={onTurnOnReminders}
      />

      <AiSocialAnalysisModal
        isOpen={isAiAnalysisOpen}
        onClose={() => setIsAiAnalysisOpen(false)}
        onAnalyse={onAnalyseSocial}
        isPremiumUser={isPremiumUser}
      />
    </div>
  );
}
